import { Box, Button, Card, CardContent, CircularProgress, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { iniciarSesion } from "../../services/authService";

const Index = () => {
    const [usuario, setUsuario] = useState("");
    const [clave, setClave] = useState("");
    const [error, setError] = useState(null);
    const [enviando, setEnviando] = useState(false);
    const navigate = useNavigate();

    const puedeEnviar = usuario.trim() !== "" && clave !== "" && !enviando;

    const enviar = async (evento) => {
        evento.preventDefault();

        if (!puedeEnviar) return;

        setEnviando(true);
        setError(null);

        try {
            await iniciarSesion(usuario.trim(), clave);
            navigate("/", { replace: true });
        }
        catch (err) {
            setError(err.response?.status === 401
                ? "Usuario o contraseña incorrectos."
                : "No se pudo iniciar sesión. Intente de nuevo.");
            setClave("");
        }
        finally {
            setEnviando(false);
        }
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", p: 2 }}>
            <Card sx={{ width: "100%", maxWidth: 380 }}>
                <CardContent sx={{ p: 4 }}>
                    <Typography variant="h5" component="h1" align="center" gutterBottom>
                        Sistema Terapéutico
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
                        Ingrese sus credenciales para continuar
                    </Typography>

                    <form onSubmit={enviar}>
                        <Stack spacing={2}>
                            <TextField
                                label="Usuario"
                                value={usuario}
                                onChange={(e) => setUsuario(e.target.value)}
                                autoFocus
                                fullWidth
                                autoComplete="username"
                                disabled={enviando}
                            />
                            <TextField
                                label="Contraseña"
                                type="password"
                                value={clave}
                                onChange={(e) => setClave(e.target.value)}
                                fullWidth
                                autoComplete="current-password"
                                disabled={enviando}
                            />

                            {error && (
                                <Typography variant="body2" color="error" role="alert">
                                    {error}
                                </Typography>
                            )}

                            <Button
                                type="submit"
                                variant="contained"
                                size="large"
                                disabled={!puedeEnviar}
                                startIcon={enviando ? <CircularProgress size={18} color="inherit" /> : null}
                            >
                                {enviando ? "Ingresando" : "Ingresar"}
                            </Button>
                        </Stack>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
}

export default Index;
